// extracted by mini-css-extract-plugin
module.exports = {"container":"Device_container__1LoJ2","red":"Device_red__2cogR","green":"Device_green__3S7Li"};